@if (
  {
    fetchingRooms: !hotelDetail || !(rooms && rooms.rooms),
    hasRooms: hotelDetail && rooms && rooms.rooms && rooms.rooms.length > 0,
    rooms: rooms,
    jitRulesReceived: jitRulesReceived
  };
  as data
) {
  <ng-template #NoAvailableRates>
    @if (!data.fetchingRooms && !data.hasRooms && data.jitRulesReceived) {
      <span class="no_rates_link" i18n="@@itemHotelsNoRatesAvailable">No Available Rates </span>
    }
  </ng-template>
  <div class="hotel-item-content">
    <h3 class="visuallyhidden">
      Result {{ index }} {{ hotelDetail.name }}
      @if (hotelDetail.hasRooms) {
        <span
          >, price from {{ rooms | hotelRoomsPrice: noOfRooms | number: '1.2-2' }}
          {{
            rooms?.rooms?.[0]?.currencyConversion?.convertedCode !==
            rooms?.rooms?.[0]?.currencyConversion?.localCode
              ? rooms.rooms[0].currencyConversion?.convertedCode
              : rooms.currencyCode
          }}
          {{ hotelDetail.availableRates.rooms[0].type }}</span
        >
      }
    </h3>
    <div class="flex-row-container width-100 hotel-result-container">
      <div class="flex-column-container hotel-item-two-box">
        <div
          #{{hotelDetail.holidayCode}}
          id="hotel-item-details-{{ hotelDetail.id }}"
          class="hotel-item-details"
        >
          <div class="flex-row-container"></div>
          <div class="hotel-information">
            <div class="flex-column-container flex-column-container--wrap hotel-information__first">
              <label
                class="hotel-item-labels"
                for="price{{ hotelDetail.id }}"
                i18n="@@itemHotelsFrom"
                >From</label
              >
              @if (!data.fetchingRooms && !data.hasRooms) {
                <span class="hotel-item-na" i18n="@@itemHotelsNotAvailable">(Not Available)</span>
              }
              @if (data.fetchingRooms) {
                <span class="hotel-item-ico">
                  <app-loading-spinner size="xs" />
                </span>
              }
              @if (data.hasRooms) {
                <div class="flex-row-container">
                  <span class="hotel-item-price" id="price{{ hotelDetail.id }}">{{
                    rooms
                      | hotelRoomsPrice: noOfRooms
                      | currency: rooms.currencyCode : 'symbol' : '1.2-2'
                  }}</span>
                  <span class="hotel-item-price-prpn"
                    >&nbsp;({{
                      rooms | hotelRoomsPrice | currency: rooms.currencyCode : 'symbol' : '1.2-2'
                    }}</span
                  >
                  <section (mouseleave)="tt2.close()" class="container">
                    <span
                      class="hotel-item-price-prpn"
                      ngbTooltip="Per Room Per Night"
                      i18n-ngbTooltip
                      aria-label="Per Room Per Night"
                      i18n-aria-label
                      triggers="manual"
                      #tt2="ngbTooltip"
                      (mouseenter)="tt2.open()"
                      >&nbsp;<span i18n="@@itemHotelsPRPN">prpn</span>)</span
                    >
                  </section>
                </div>
              }
              @if (data.hasRooms) {
                <div class="flex-row-container flex-row-container--wrap">
                  @if (rooms.currencyCode !== localCurrency) {
                    <span class="hotel-item-price-prpn">
                      @if (getConvertedTotal(rooms); as convertedTotal) {
                        (<span i18n="@@itemHotelsRoomRateApprox">Average room rate approx</span>:
                        {{ convertedTotal }} {{ localCurrency }}
                        {{ convertedTotal / noOfNights | number: '1.2-2' }}
                        <section (mouseleave)="tt3.close()" class="container">
                          <span
                            i18n-ngbTooltip
                            i18n-aria-label
                            ngbTooltip="Per Room Per Night"
                            aria-label="Per Room Per Night"
                            triggers="manual"
                            #tt3="ngbTooltip"
                            i18n="@@itemHotelsPRPN"
                            (mouseenter)="tt3.open()"
                            >prpn</span
                          >
                        </section>
                        )
                      }
                    </span>
                  }
                </div>
              }
              <p class="price-detail" i18n="@@itemHotelsPriceRooms">
                Price for {{ noOfRooms }} {noOfRooms, plural, =1 {room} other {rooms}}
                {{ noOfNights }} {noOfNights, plural, =1 {night} other {nights}}
              </p>
              @if (data?.rooms?.rooms) {
                @if (data?.rooms?.rooms.length < 6 && data?.rooms?.rooms.length > 0) {
                  <span class="rates_warning" i18n="@@hotelItemBookNow"
                    >Book now to secure this rate</span
                  >
                }
                @if (data?.rooms?.rooms.length >= 6 && data?.rooms?.rooms.length < 11) {
                  <span class="rates_warning" i18n="@@hotelItemLastFew"
                    >Last few rooms available</span
                  >
                }
              }
            </div>
            <div class="flex-column-container hotel-nameanddetails">
              <div class="flex-row-container flex-column-mobile">
                <p class="hotel-item-name" [innerHTML]="hotelDetail.name"></p>
              </div>
              <!-- Changed to inner html as some hotel names have html in them  -->
              <p class="hotel-address">{{ getAddress(hotelDetail) }}</p>
              @if (!hotelDetail.location) {
                <span class="location_span" i18n="@@itemHotelsLocationDataNA">
                  Location data not available.
                </span>
              }
              @if (hotelDetail.stars) {
                <p class="stars_container">
                  <ng-container>
                    @if (hotelDetail.stars >= 0.5) {
                      <i
                        class="ico-star"
                        [ngClass]="{ half_star: hotelDetail.stars === 0.5 }"
                        aria-hidden="true"
                      ></i>
                    }
                    @if (hotelDetail.stars >= 1.5) {
                      <i
                        class="ico-star"
                        [ngClass]="{ half_star: hotelDetail.stars === 1.5 }"
                        aria-hidden="true"
                      ></i>
                    }
                    @if (hotelDetail.stars >= 2.5) {
                      <i
                        class="ico-star"
                        [ngClass]="{ half_star: hotelDetail.stars === 2.5 }"
                        aria-hidden="true"
                      ></i>
                    }
                    @if (hotelDetail.stars >= 3.5) {
                      <i
                        class="ico-star"
                        [ngClass]="{ half_star: hotelDetail.stars === 3.5 }"
                        aria-hidden="true"
                      ></i>
                    }
                    @if (hotelDetail.stars >= 4.5) {
                      <i
                        class="ico-star"
                        [ngClass]="{ half_star: hotelDetail.stars === 4.5 }"
                        aria-hidden="true"
                      ></i>
                    }
                    <span class="sr-only"
                      >{{ hotelDetail.stars }}&nbsp;<span i18n="@@itemHotelsStars"
                        >stars</span
                      ></span
                    >
                  </ng-container>
                </p>
              }
            </div>
          </div>
          <div class="hotel-geo">
            <div class="flex-row-container flex-row-container--right flex-column-mobile">
              <div class="title_icons">
                <app-preferred-icons
                  [tmcPreferred]="showTMCPreferredLogo"
                  [tmcPreferredLogoUrl]="tmcPreferredLogo"
                  [tmcPreferredMessage]="tmcPreferredMessage"
                  [clientPreferred]="preferred"
                  [companyPreferredMessage]="companyPreferredMessage"
                  [officePreferredMessage]="officePreferredMessage"
                >
                </app-preferred-icons>
                @if (hotelDetail.preferred.client) {
                  <section (mouseleave)="tt4.close()" class="container">
                    <app-image-with-error
                      alt="Preferred supplier logo"
                      componentId="preferred-client-{{ hotelDetail.id }}"
                      logoUrl="{{ preferredLogoUrl?.imageSrc }}"
                      errorIcon="ico-heart"
                      ngbTooltip="Preferred"
                      aria-label="Preferred"
                      i18n-ngbTooltip="@@HotelIconPreferred"
                      triggers="manual"
                      #tt4="ngbTooltip"
                      (mouseenter)="tt4.open()"
                      (focus)="tt4.open()"
                      (blur)="tt4.close()"
                      class="flex-row-container preferred-icon"
                    >
                    </app-image-with-error>
                  </section>
                }
                @if (hotelGroupTags?.staticTags?.length) {
                  @for (staticTag of hotelGroupTags.staticTags; track staticTag) {
                    @if (staticTag.displayType === staticTagDisplay.Featured) {
                      <div class="hotel-featured-tag">
                        <section (mouseleave)="ttHGF.close()" class="container">
                          @if (
                            !staticTag.displayText && iconLibrary.definitions.far[staticTag.icon]
                          ) {
                            <fa-icon
                              [icon]="iconLibrary.definitions.far[staticTag.icon]"
                              triggers="manual"
                              #ttHGF="ngbTooltip"
                              (mouseenter)="ttHGF.open()"
                              (focus)="ttHGF.open()"
                              (blur)="ttHGF.close()"
                              tabindex="0"
                              [ngbTooltip]="staticTag.name | translate"
                              [attr.aria-label]="staticTag.name"
                            ></fa-icon>
                          }
                          @if (staticTag.displayText) {
                            <span class="static_tag_text">
                              {{ staticTag.name | translate }}
                            </span>
                          }
                        </section>
                      </div>
                    }
                  }
                }
                @if (hotelRatingsInfo?.staticTags?.length) {
                  @for (staticTag of hotelRatingsInfo.staticTags; track staticTag) {
                    @if (staticTag.displayType === staticTagDisplay.Featured) {
                      <div class="hotel-featured-tag">
                        <section (mouseleave)="ttHF.close()" class="container">
                          @if (
                            !staticTag.displayText && iconLibrary.definitions.far[staticTag.icon]
                          ) {
                            <fa-icon
                              [icon]="iconLibrary.definitions.far[staticTag.icon]"
                              triggers="manual"
                              #ttHF="ngbTooltip"
                              (mouseenter)="ttHF.open()"
                              (focus)="ttHF.open()"
                              (blur)="ttHF.close()"
                              tabindex="0"
                              [ngbTooltip]="staticTag.name | translate"
                              [attr.aria-label]="staticTag.name"
                            ></fa-icon>
                          }
                          @if (staticTag.displayText) {
                            <span class="static_tag_text">
                              {{ staticTag.name | translate }}
                            </span>
                          }
                        </section>
                      </div>
                    }
                  }
                }
              </div>
              @if (hotelDetail.transports?.length && displayLocationData) {
                <div class="location_span">
                  <h4 class="location_header">
                    <span i18n="@@itemHotelsLocation">Location</span>:
                  </h4>
                  <dl>
                    @for (transport of hotelDetail.transports; track transport) {
                      @if (transport.type === hotelDetailTypes.METRO) {
                        <div class="inline-dl">
                          <dt>
                            <i class="ico-metro" aria-hidden="true"></i>
                            <span class="visuallyhidden"
                              >Distance from Closest Underground Station</span
                            >
                          </dt>
                          <dd>
                            {{
                              transport | switchDistanceFormat: distanceUnit | number: '1.1-1'
                            }}&nbsp;
                            <span i18n="@@itemHotelsDistanceTypes">{{
                              distanceUnit | lowercase
                            }}</span>
                          </dd>
                        </div>
                      }
                      @if (transport.type === hotelDetailTypes.TRAIN) {
                        <div class="inline-dl">
                          <dt>
                            <i class="ico-rail" aria-hidden="true"></i>
                            <span class="visuallyhidden">Distance from Closest Train Station</span>
                          </dt>
                          <dd>
                            {{ transport | switchDistanceFormat: distanceUnit | number: '1.1-1' }}
                            <span i18n="@@itemHotelsDistanceTypes">{{
                              distanceUnit | lowercase
                            }}</span>
                          </dd>
                        </div>
                      }
                      @if (transport.type === hotelDetailTypes.AIRPORT) {
                        <div class="inline-dl">
                          <dt>
                            <i class="ico-flight" aria-hidden="true"></i>
                            <span class="visuallyhidden">Distance from Closest Airport</span>
                          </dt>
                          <dd>
                            {{
                              transport | switchDistanceFormat: distanceUnit | number: '1.1-1'
                            }}&nbsp;
                            <span i18n="@@itemHotelsDistanceTypes">{{
                              distanceUnit | lowercase
                            }}</span>
                          </dd>
                        </div>
                        <div class="inline-dl">
                          <dt>
                            <i class="ico-flight" aria-hidden="true"></i>
                            <span class="visuallyhidden">Closest Airport name</span>
                          </dt>
                          <dd>
                            {{ transport.name }}
                          </dd>
                        </div>
                      }
                    }
                  </dl>
                </div>
              }
            </div>
            <div class="ratings-and-featured-tags">
              <div class="flex-row-container">
                @if (
                  (hotelRatingsInfo || hotelGroupTags) &&
                  (hotelRatingsInfo?.rating ||
                    hotelRatingsInfo?.staticTags?.length ||
                    hotelGroupTags?.staticTags?.length ||
                    hotelRatingsInfo.numberOfBookings)
                ) {
                  @if (hotelRatingsInfo?.rating) {
                    <section (mouseleave)="ttHR.close()" class="container">
                      <div
                        class="hotel-rating"
                        #ttHR="ngbTooltip"
                        (mouseenter)="ttHR.open()"
                        (focus)="ttHR.open()"
                        (blur)="ttHR.close()"
                        tabindex="0"
                        i18n-ngbTooltip
                        ngbTooltip="This score is the average based on users who stayed at this property from your company."
                        (click)="openHotelReviewsDialog()"
                        (keyup.enter)="openHotelReviewsDialog()"
                        role="button"
                        [attr.aria-label]="'View User Ratings for ' + hotelDetail.name"
                      >
                        {{ hotelRatingsInfo.rating.toFixed(1).replace('.0', '') }}/5
                      </div>
                    </section>
                  }
                  @if (hotelGroupTags && hotelGroupTags.staticTags?.length) {
                    @for (staticTag of hotelGroupTags.staticTags; track staticTag) {
                      @if (
                        staticTag.displayType === staticTagDisplay.Standard &&
                        iconLibrary.definitions.far[staticTag.icon]
                      ) {
                        <div class="hotel-standard-tag">
                          <section (mouseleave)="ttHS.close()" class="container">
                            <fa-icon
                              [icon]="iconLibrary.definitions.far[staticTag.icon]"
                              triggers="manual"
                              #ttHS="ngbTooltip"
                              (mouseenter)="ttHS.open()"
                              (focus)="ttHS.open()"
                              (blur)="ttHS.close()"
                              tabindex="0"
                              [ngbTooltip]="staticTag.name | translate"
                              [attr.aria-label]="staticTag.name"
                            ></fa-icon>
                          </section>
                        </div>
                      }
                    }
                  }
                  @if (hotelRatingsInfo && hotelRatingsInfo.staticTags?.length) {
                    @for (staticTag of hotelRatingsInfo.staticTags; track staticTag) {
                      @if (
                        staticTag.displayType === staticTagDisplay.Standard &&
                        iconLibrary.definitions.far[staticTag.icon]
                      ) {
                        <div class="hotel-standard-tag">
                          <section (mouseleave)="ttHS.close()" class="container">
                            <fa-icon
                              [icon]="iconLibrary.definitions.far[staticTag.icon]"
                              triggers="manual"
                              #ttHS="ngbTooltip"
                              (mouseenter)="ttHS.open()"
                              (focus)="ttHS.open()"
                              (blur)="ttHS.close()"
                              tabindex="0"
                              [ngbTooltip]="staticTag.name | translate"
                              [attr.aria-label]="staticTag.name"
                            ></fa-icon>
                          </section>
                        </div>
                      }
                    }
                  }
                }
                @if (hotelDetail.sortedTags?.length) {
                  <ul
                    class="preferred-container"
                    aria-label="Hotel amenities"
                    i18n-aria-label="@@hotelAmenitiesListLabel"
                  >
                    @for (tag of hotelDetail.sortedTags | slice: 0 : 3; track tag; let i = $index) {
                      <li
                        class="flex-row-container flex-row-container--v-center preferred-container__item"
                      >
                        @if (tag.name === AmenitiesSearchHandler.ECO_FRIENDLY && faLeaf) {
                          <div class="eco-friendly-icon" (mouseleave)="tt1.close()">
                            <fa-icon
                              triggers="manual"
                              #tt1="ngbTooltip"
                              (mouseenter)="tt1.open()"
                              [ngbTooltip]="tag.display | translate"
                              [attr.aria-label]="tag.display | translate"
                              (focus)="tt1.open()"
                              (blur)="tt1.close()"
                              tabindex="0"
                              [icon]="faLeaf"
                            >
                            </fa-icon>
                          </div>
                        } @else {
                          <section (mouseleave)="tt6.close()" class="container">
                            <img
                              src="{{ tag.icon }}"
                              height="24"
                              width="24"
                              class="tag-img"
                              [ngbTooltip]="tag.display | translate"
                              triggers="manual"
                              #tt6="ngbTooltip"
                              (mouseenter)="tt6.open()"
                              (focus)="tt6.open()"
                              (blur)="tt6.close()"
                              tabindex="0"
                              [alt]="tag.display | translate"
                            />
                          </section>
                        }
                      </li>
                    }
                  </ul>
                  @if (hotelDetail.sortedTags.length >= 3) {
                    <div
                      class="preferred-container__more"
                      (click)="open(hotelDetail)"
                      role="button"
                      tabindex="0"
                      (keyup.enter)="open(hotelDetail)"
                    >
                      <span i18n="@@itemHotelsMore">more</span>
                      <span class="visuallyhidden" i18n="@@itemHotelsAmenitiesFor"
                        >amenities for</span
                      >
                      <span class="visuallyhidden">{{ hotelDetail.name }}</span
                      >&hellip;
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
        <div class="item-hotels-details">
          <div class="flex-row-container flex-column-mobile">
            <button
              type="button"
              class="item-hotels-img-container"
              (click)="openHotelPhotosDialog()"
              [attr.aria-label]="
                'View photos for ' + (hotelDetail.name ? hotelDetail.name : 'hotel')
              "
            >
              <img
                [src]="imageUrl"
                class="hotel-item-image"
                alt="image of {{ hotelDetail.name ? hotelDetail.name : 'hotel' }}"
              />
              <div class="hotel-item-distance">
                <span i18n="@@itemHotelsDistance2" class="visuallyhidden">Distance</span>
                <fa-icon aria-hidden="true" [icon]="faLocationDot"> </fa-icon>
                <span class="hotel-item-distance-details" id="distance-details-{{ hotelDetail.id }}"
                  >{{ hotelDetail.location | switchDistanceFormat: distanceUnit | number: '1.1-1' }}
                  <span i18n="@@itemHotelsDistanceTypes">{{ distanceUnit | lowercase }}</span>
                </span>
              </div>
              @if (hotelRatingsInfo?.numberOfBookings) {
                <div class="booked_before">
                  <span i18n="@@hotelBookedBefore">Your company has booked this hotel</span>
                  @if (hotelRatingsInfo.numberOfBookings === 1) {
                    <span i18n="@@hotelBookedBeforeSingle">&nbsp;before!</span>
                  }
                  @if (
                    hotelRatingsInfo.numberOfBookings > 1 &&
                    hotelRatingsInfo.numberOfBookings < 1000
                  ) {
                    <span i18n="@@hotelBookedBeforeMultiple"
                      >&nbsp;{{ hotelRatingsInfo.numberOfBookings }} times before!</span
                    >
                  }
                  @if (hotelRatingsInfo.numberOfBookings >= 1000) {
                    <span i18n="@@hotelBookedBeforeLot">&nbsp;a lot!</span>
                  }
                </div>
              }
            </button>
            <div class="flex-column-container width-100">
              <div class="hotel-item-icon-list">
                @if (
                  data.jitRulesReceived &&
                    hotelDetail.receivedJitRules &&
                    !hotelDetail.jitRemoveResultRule &&
                    data?.rooms?.rooms?.length &&
                    (data?.rooms?.rooms | hotelRoomsStatus);
                  as roomsStatus
                ) {
                  <table
                    class="hotel-rates-table"
                    role="table"
                    [attr.aria-label]="
                      'Available rooms and rates for ' +
                      (hotelDetail.name ? hotelDetail.name : 'hotel')
                    "
                  >
                    <thead class="visuallyhidden" role="rowgroup">
                      <tr role="row">
                        <th scope="col" role="columnheader" i18n="@@hotelTableColPrice">Price</th>
                        <th scope="col" role="columnheader" i18n="@@hotelTableColRoom">Room</th>
                        <th scope="col" role="columnheader" i18n="@@hotelTableColConditions">
                          Booking Conditions
                        </th>
                        <th scope="col" role="columnheader" i18n="@@hotelTableColActions">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody role="rowgroup">
                      @for (
                        room of data?.rooms?.rooms | orderHotelRoom;
                        track room;
                        let roomIndex = $index
                      ) {
                        @if (roomIndex < 3) {
                          <tr
                            class="flex-row-container hotel-room-container"
                            id="hotel-room-{{ roomIndex }}"
                            role="row"
                          >
                            <td
                              class="hotel-room-price"
                              id="hotel-price-{{ hotelDetail.id }}-{{ roomIndex }}"
                              role="cell"
                            >
                              {{ room.total * noOfRooms | currency: room.currencyCode : 'symbol' }}
                              <app-breakfast-icon [room]="room"></app-breakfast-icon>
                              @if (
                                room.currencyConversion?.convertedCode !==
                                room.currencyConversion?.localCode
                              ) {
                                <span class="hotel-room-approx">
                                  (
                                  <span i18n="@@ratesHotelApproxRate">Approx</span>:
                                  {{
                                    room.currencyConversion.convertedTotal
                                      | currency: room.currencyConversion.convertedCode
                                  }}
                                  )
                                </span>
                              }
                            </td>
                            <td
                              id="hotel-room-name-{{ hotelDetail.id }}-{{ roomIndex }}"
                              class="hotel-room-name"
                              role="cell"
                            >
                              <app-warning-tags
                                iconId="{{ hotelDetail.id }}-{{ roomIndex }}"
                                [ticket]="room"
                                [displayCheck]="true"
                              ></app-warning-tags>
                              {{ room.roomType | translate }}
                            </td>
                            <td class="hotel-room-conditions" role="cell">
                              <button
                                class="gmt-fare-rules-link"
                                (click)="
                                  openFareRules(
                                    room,
                                    hotelDetail.availableRates?.source,
                                    hotelDetail.name
                                  )
                                "
                                tabindex="0"
                                role="link"
                              >
                                <span aria-hidden="true">
                                  <i class="gmt-currency-info-icon currency_info_icon"></i>
                                </span>
                                <span class="visuallyhidden"
                                  >{{ room?.total | currency: room.currencyCode }}
                                  {{ hotelDetail.name }} hotel fare&nbsp;</span
                                >
                                <span i18n="@@boltBookingConditions">Booking Conditions</span>
                              </button>
                            </td>
                            <td class="hotel-room-actions" role="cell">
                              <button
                                appButton="small"
                                class="add-room-button"
                                i18n="@@HotelAddRoomBtn"
                                attr.aria-label="Add room {{
                                  room.total * noOfRooms | currency: room.currencyCode : 'symbol'
                                }} {{ room.roomType }} to basket - {{ hotelDetail.name }}"
                                id="add-room-{{ hotelDetail.id }}-{{ roomIndex }}"
                                (click)="addToCart(room)"
                                [disabled]="room.unavailable"
                              >
                                Add Room
                              </button>
                            </td>
                          </tr>
                        }
                      }
                    </tbody>
                  </table>
                }
                @if (
                  !data.jitRulesReceived ||
                  !hotelDetail.receivedJitRules ||
                  (!(data?.rooms | keyvalue).length && hotelDetail.jitRemoveResultRule) ||
                  (hotelDetail.jitRemoveResultRule && data?.rooms?.rooms?.length)
                ) {
                  <div class="rates-applying-message" i18n="@@itemHotelsRatesDisplayWhenApplied">
                    Rates will be displayed when policy has been applied.
                  </div>
                }
                @if (data.fetchingRooms) {
                  <div class="rates-applying-message" i18n="@@itemHotelsLoadingRates">
                    Loading Rates...
                  </div>
                }
                @if (!data.fetchingRooms && !data.hasRooms && data.jitRulesReceived) {
                  <div class="rates-applying-message" i18n="@@itemHotelsNoRatesAvailabl">
                    No Available Rates.
                  </div>
                }
              </div>
              <div class="item-buttons">
                @if (hotelDetail) {
                  <div
                    class="info-box"
                    id="wellbeing-see-all-rates-info-box-{{ hotelDetail.id }}"
                    (click)="openHotelResultModal(0)"
                    role="link"
                    [ngClass]="{
                      no_event:
                        !data.jitRulesReceived ||
                        hotelDetail.jitRemoveResultRule ||
                        !hotelDetail.receivedJitRules
                    }"
                    (keyup.enter)="openHotelResultModal(0)"
                    tabindex="0"
                  >
                    @if (
                      data.jitRulesReceived &&
                      hotelDetail.receivedJitRules &&
                      (data?.rooms | keyvalue).length &&
                      !hotelDetail.jitRemoveResultRule &&
                      data?.rooms?.rooms?.length
                    ) {
                      <span>
                        <span i18n="@@itemHotelsSeeAll">See All</span>
                        {{ data.rooms.rooms.length }}
                        <span i18n="@@itemHotelsRates">Rates</span>
                        <span class="visuallyhidden">&nbsp; for {{ hotelDetail.name }}</span>
                      </span>
                    } @else {
                      @if (!data.fetchingRooms && !data.hasRooms && data.jitRulesReceived) {
                        <span class="no_rates_link" i18n="@@itemHotelsNoRatesAvailable"
                          >No Available Rates
                        </span>
                      }
                    }
                    @if (
                      !data.jitRulesReceived ||
                      !hotelDetail.receivedJitRules ||
                      (!(data?.rooms | keyvalue).length && hotelDetail.jitRemoveResultRule) ||
                      (hotelDetail.jitRemoveResultRule && data?.rooms?.rooms?.length) ||
                      data.fetchingRooms
                    ) {
                      <div>
                        <!-- Applying policy -->
                        <app-loading-spinner size="xs" />
                      </div>
                    }
                  </div>
                }
                @if (showAllPhotos) {
                  <div
                    class="info-box"
                    id="wellbeing-show-photos-info-box"
                    (click)="openHotelResultModal(1)"
                    (keyup.enter)="openHotelResultModal(1)"
                    i18n="@@itemHotelsSeePhotos"
                    role="button"
                    tabindex="0"
                  >
                    See Photos
                  </div>
                }
                <div
                  class="info-box"
                  id="wellbeing-map-info-box"
                  (click)="showOnMap()"
                  (keyup.enter)="showOnMap()"
                  role="button"
                  i18n="@@itemHotelsMap"
                  tabindex="0"
                >
                  Map
                </div>
                <div
                  (click)="openHotelResultModal(2)"
                  (keyup.enter)="openHotelResultModal(2)"
                  id="wellbeing-info-box"
                  class="info-box"
                  role="button"
                  i18n="@@itemHotelsInfo"
                  tabindex="0"
                >
                  Info
                </div>
                @if (hotelRatingsInfo && hotelRatingsInfo.rating) {
                  <div
                    (click)="openHotelResultModal(3)"
                    (keyup.enter)="openHotelResultModal(3)"
                    class="info-box"
                    role="button"
                    i18n="@@itemHotelsShowUserReview"
                    tabindex="0"
                  >
                    User Review
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
